import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { saveTabSessionStorageResp } from "../../../actions/TabSessionStorage";
import { TabData } from "../../../models/TabSessionStorage";
import RequestServices from "../components/RequestServices";
import { getCareTypes, getDisciplineList } from "../../../actions/Master";
import { getListResult } from "../../../utils";
import { SlotsPayload } from "../../../models/Referral";
import { getDisciplineStatusList, getSlots } from "../../../actions/ReferralAction";

const mapStateToProps = ({
  tabSessionStorageReAuthState,
  masterCareTypeState,
  disciplineListState,
  loggedInUserState,
  informationState,
  patientInformationByIdState,
  slotsState,
  reAuthReferralDetailState,
  memberInfoDataState,
  disciplineStatusState
}: ApplicationState) => ({
  tabSessionStorageReAuthState: tabSessionStorageReAuthState.response,
  masterCareTypeState: getListResult(masterCareTypeState.response),
  disciplineListState: disciplineListState.response,
  loggedInUserState: loggedInUserState.response,
  informationState: informationState.response,
  patientInformationByIdState: patientInformationByIdState.response,
  memberInfoDataState: memberInfoDataState.response,
  slotsState: slotsState.response,
  reAuthReferralDetailState: reAuthReferralDetailState.response,
  disciplineStatusState: disciplineStatusState.response,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
    return {
      resetStates: (actionType: string, field?: string) => {
        dispatch(resetStates(actionType, field));
      },
      saveTabSessionStorage: (SessionData: TabData) => {
        dispatch(saveTabSessionStorageResp(SessionData));
      },
      getCareTypes: () => {
        dispatch(getCareTypes());
      },
      getDisciplineList: (eligibilityId: number, isPortal: boolean, type: number) => {
        dispatch(getDisciplineList(eligibilityId, isPortal, type));
      },
      getSlots: (payload: SlotsPayload) => {
        dispatch(getSlots(payload));
      },
      getDisciplineStatusList: (referralId: string) => {
        dispatch(getDisciplineStatusList(referralId));
      },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestServices);